import React from 'react';
import { X, Star, Zap, Check } from 'lucide-react';
import { formatPrice } from '../data/products';

export default function ProductModal({ product, onClose }) {
  if (!product) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(6px)',
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        animation: 'fadeIn 0.2s ease',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 'var(--radius-lg)',
          maxWidth: '700px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: 'var(--shadow-lg)',
          animation: 'fadeInUp 0.3s ease',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 16px 0' }}>
          <button
            onClick={onClose}
            style={{
              background: 'var(--gray-100)',
              border: 'none',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: 'var(--gray-600)',
            }}
          >
            <X size={18} />
          </button>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '0',
          padding: '0 32px 32px',
        }}>
          {/* Imagen */}
          <div>
            <img
              src={product.image}
              alt={product.name}
              style={{
                width: '100%',
                borderRadius: 'var(--radius)',
                objectFit: 'cover',
                aspectRatio: '1',
                background: 'var(--green-pale)',
              }}
            />
          </div>

          {/* Info */}
          <div style={{ padding: '0 0 0 28px' }}>
            {product.badge && (
              <span style={{
                background: product.badgeColor,
                color: 'white',
                fontSize: '12px',
                fontWeight: 800,
                padding: '4px 12px',
                borderRadius: '50px',
                display: 'inline-block',
                marginBottom: '12px',
              }}>
                {product.badge}
              </span>
            )}

            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: '1.5rem',
              color: 'var(--gray-800)',
              lineHeight: 1.3,
              marginBottom: '12px',
            }}>
              {product.name}
            </h2>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
              {[1,2,3,4,5].map(i => (
                <Star key={i} size={16}
                  fill={i <= Math.round(product.rating) ? 'var(--orange)' : 'none'}
                  color={i <= Math.round(product.rating) ? 'var(--orange)' : 'var(--gray-400)'}
                />
              ))}
              <span style={{ fontSize: '14px', color: 'var(--gray-400)' }}>
                {product.rating} ({product.reviews} reseñas)
              </span>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <span style={{ fontSize: '2rem', fontWeight: 900, color: 'var(--green-dark)' }}>
                {formatPrice(product.price)}
              </span>
              {product.originalPrice && (
                <span style={{ fontSize: '15px', color: 'var(--gray-400)', textDecoration: 'line-through', marginLeft: '10px' }}>
                  {formatPrice(product.originalPrice)}
                </span>
              )}
            </div>

            <p style={{ fontSize: '14px', color: 'var(--gray-600)', lineHeight: 1.6, marginBottom: '20px' }}>
              {product.description}
            </p>

            {/* Features */}
            <div style={{ marginBottom: '28px' }}>
              {product.features?.map((f, i) => (
                <div key={i} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '6px',
                  fontSize: '14px',
                  color: 'var(--gray-700)',
                }}>
                  <Check size={15} color="var(--green-mid)" strokeWidth={2.5} />
                  {f}
                </div>
              ))}
            </div>

            {/* Botón comprar */}
            <a
              href={product.paymentLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                width: '100%',
                background: 'var(--orange)',
                color: 'white',
                border: 'none',
                borderRadius: '14px',
                padding: '16px',
                fontFamily: 'var(--font-main)',
                fontWeight: 800,
                fontSize: '16px',
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'background 0.2s, transform 0.15s',
                boxSizing: 'border-box',
                boxShadow: '0 4px 16px rgba(232,134,10,0.35)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#d4740a';
                e.currentTarget.style.transform = 'scale(1.02)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'var(--orange)';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <Zap size={20} />
              Comprar ahora
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
